import React from 'react';
import { Table } from 'react-bootstrap';
import { 
    BAC_DAO_TAO,
    VAI_TRO_BAI_BAO, 
    VAI_TRO_DE_TAI, 
    CAP_DE_TAI, 
    XEP_LOAI_KET_QUA, 
    VAI_TRO_SANG_CHE, 
    VAI_TRO_SACH, 
    BAC_HOC_VIEN,
    trangThaiPheDuyetValue
} from '@app/utils/define';
import { formatDateTimeWithoutHour } from '@app/utils/helper';
import { BaseGatewayImage } from '@app/utils/apiUrl';

const isRichTextEmpty = (html) => {
    if (!html) return true;
    const cleanText = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
    return cleanText === '';
};

const PrintLayoutV2 = ({
    nhanVien = {},
    tenDonVi = '',
    quaTrinhDaoTao = [],
    ngoaiNgu = [],
    baiBao: rawBaiBao = [],
    deTai: rawDeTai = [],
    sangChe: rawSangChe = [],
    sach: rawSach = [],
    huongDanHocVien: rawHuongDanHocVien = []
}) => {
    const baiBao = rawBaiBao.filter(b => b.trangThaiPheDuyet === trangThaiPheDuyetValue.daPheDuyet);
    const deTai = rawDeTai.filter(d => d.trangThaiPheDuyet === trangThaiPheDuyetValue.daPheDuyet);
    const sangChe = rawSangChe.filter(s => s.trangThaiPheDuyet === trangThaiPheDuyetValue.daPheDuyet);
    const sach = rawSach.filter(s => s.trangThaiPheDuyet === trangThaiPheDuyetValue.daPheDuyet);
    const huongDanHocVien = rawHuongDanHocVien.filter(h => h.trangThaiPheDuyet === trangThaiPheDuyetValue.daPheDuyet);

    let indexPart1 = 1;
    let indexPart2 = 1;

    return (
        <div className="d-none d-print-block print-container-v2" style={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '13pt', color: 'black', lineHeight: '1.5' }}>
            <table className="print-layout-table">
                <thead>
                    <tr>
                        <td>
                            <div style={{ height: '2.5cm' }}></div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="print-layout-content-cell">
                            <div className="text-center mb-4">
                                <h4 className="font-weight-bold text-uppercase" style={{ fontSize: '15pt', letterSpacing: '1px' }}>THÔNG TIN HỒ SƠ KHOA HỌC CÁ NHÂN</h4>
                                <div className="font-weight-bold" style={{ fontSize: '14pt' }}>----------</div>
                                <h5 className="font-weight-bold mt-4 text-uppercase" style={{ fontSize: '13pt' }}>PHẦN I (Thông tin tóm tắt)</h5>
                            </div>

                            <div className="text-center mb-4">
                                <div className="print-avatar-container" style={{ width: '100px', height: '120px', border: '1px solid #17a2b8', display: 'inline-block', marginBottom: '10px', overflow: 'hidden', verticalAlign: 'middle' }}>
                                    {nhanVien.hinhAnh ? (
                                        <img
                                            className="print-avatar-img"
                                            src={nhanVien.hinhAnh.startsWith('http') ? nhanVien.hinhAnh : BaseGatewayImage + (nhanVien.hinhAnh.startsWith('/') ? '' : '/') + nhanVien.hinhAnh}
                                            alt="Avatar"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <span style={{ color: '#17a2b8', fontSize: '10pt', display: 'block', marginTop: '45px' }}>[Ảnh]</span>
                                    )}
                                </div>
                                <h4 className="font-weight-bold" style={{ fontSize: '14pt', margin: '5px 0' }}>
                                    {(() => {
                                        const isPGS = Number(nhanVien.chucDanhKHCaoNhat) === 24;
                                        const isGS = Number(nhanVien.chucDanhKHCaoNhat) === 25;
                                        const prefix = isGS ? 'GS, ' : (isPGS ? 'PGS, ' : '');
                                        
                                        const isTS = Number(nhanVien.hocViCaoNhat) === 22 || Number(nhanVien.hocViCaoNhat) === 23;
                                        const isThS = Number(nhanVien.hocViCaoNhat) === 21;
                                        const suffix = isTS ? 'TS' : (isThS ? 'ThS' : '');
                                        
                                        return `${prefix}${suffix} ${nhanVien.hoTen || ''}`.trim();
                                    })()}
                                </h4>
                                <div className="font-weight-bold" style={{ fontSize: '12pt', fontStyle: 'italic' }}>
                                    {nhanVien.chucVu && `${nhanVien.chucVu}, `}{tenDonVi || nhanVien.tenDonViTuNhap || 'Bệnh viện TWQĐ 108'}
                                </div>
                            </div>

                            {/* Mục 1: Giới thiệu */}
                            {!isRichTextEmpty(nhanVien.gioiThieuChung) && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart1++}. Giới thiệu</h5>
                                    <div className="print-box-teal">
                                        <div dangerouslySetInnerHTML={{ __html: nhanVien.gioiThieuChung }} />
                                        <div className="mt-3 font-weight-bold" style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px dashed #e0e0e0', paddingTop: '10px', fontSize: '11pt' }}>
                                            <span>Điện thoại: {nhanVien.dienThoaiDiDong || 'Chưa cập nhật'}</span>
                                            <span>Email: {nhanVien.emailCongViec || 'Chưa cập nhật'}</span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Mục 2: Trình độ học vấn */}
                            {(quaTrinhDaoTao.length > 0 || ngoaiNgu.length > 0 || (nhanVien.chucDanhKHCaoNhat !== 1 && nhanVien.chucDanhKHCaoNhat !== undefined)) && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart1++}. Trình độ học vấn</h5>
                                    <div className="print-box-teal">
                                        <ul style={{ margin: 0, paddingLeft: '20px', lineHeight: '1.8' }}>
                                            {quaTrinhDaoTao.map((d, idx) => {
                                                const labelBac = BAC_DAO_TAO.find(o => o.value === Number(d.bacDaoTao))?.label || d.bacDaoTao || '';
                                                let degreeName = String(labelBac);
                                                if (degreeName.includes('(')) {
                                                    degreeName = degreeName.split('(')[0].trim();
                                                }
                                                
                                                if (d.bacDaoTao === 1 && d.chuyenNganh) {
                                                    const cnLower = d.chuyenNganh.toLowerCase();
                                                    if (cnLower.includes('bác sĩ') || cnLower.includes('bac si')) {
                                                        degreeName = 'Bác sĩ';
                                                    } else if (cnLower.includes('dược sĩ') || cnLower.includes('duoc si')) {
                                                        degreeName = 'Dược sĩ';
                                                    } else if (cnLower.includes('kỹ sư') || cnLower.includes('ky su')) {
                                                        degreeName = 'Kỹ sư';
                                                    } else if (cnLower.includes('cử nhân') || cnLower.includes('cu nhan')) {
                                                        degreeName = 'Cử nhân';
                                                    }
                                                }

                                                const hasSpecialization = d.chuyenNganh && 
                                                    d.chuyenNganh.toLowerCase() !== degreeName.toLowerCase() &&
                                                    d.chuyenNganh.toLowerCase() !== 'bác sĩ đa khoa' &&
                                                    d.chuyenNganh.toLowerCase() !== 'bac si da khoa';

                                                return (
                                                    <li key={idx}>
                                                        <strong>{degreeName}</strong>
                                                        {hasSpecialization ? `, ${d.chuyenNganh}` : ''} ({d.namTotNghiep}), {d.truongDaoTao}
                                                    </li>
                                                );
                                            })}
                                            {(Number(nhanVien.chucDanhKHCaoNhat) === 24 || Number(nhanVien.chucDanhKHCaoNhat) === 25) && (
                                                <li>
                                                    <strong>{Number(nhanVien.chucDanhKHCaoNhat) === 24 ? 'Phó Giáo sư' : 'Giáo sư'}</strong> ({nhanVien.namChucDanh || 'Chưa cập nhật'}), {nhanVien.noiBoNhiemChucDanh || 'Chưa cập nhật'}
                                                </li>
                                            )}
                                            {ngoaiNgu.length > 0 && (
                                                <li>
                                                    <strong>Ngoại ngữ:</strong> {ngoaiNgu.map(n => `${n.tenNgoaiNgu} ${n.mucDo}${n.noiCap ? ` (${n.noiCap})` : ''}`).join(', ')}
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            {/* Mục 3: Chuyên ngành, thế mạnh chuyên môn */}
                            {!isRichTextEmpty(nhanVien.chuyenNganhLinhVuc) && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart1++}. Chuyên ngành, thế mạnh chuyên môn</h5>
                                    <div className="print-box-teal">
                                        <div dangerouslySetInnerHTML={{ __html: nhanVien.chuyenNganhLinhVuc }} />
                                    </div>
                                </div>
                            )}

                            {/* Mục 4: Kinh nghiệm làm việc */}
                            {!isRichTextEmpty(nhanVien.kinhNghiemLamViec) && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart1++}. Kinh nghiệm làm việc</h5>
                                    <div className="print-box-teal">
                                        <div dangerouslySetInnerHTML={{ __html: nhanVien.kinhNghiemLamViec }} />
                                    </div>
                                </div>
                            )}

                            {/* Mục 5: Công trình nghiên cứu, xuất bản và đào tạo */}
                            {!isRichTextEmpty(nhanVien.congTrinhNBXB) && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart1++}. Công trình nghiên cứu, xuất bản và đào tạo</h5>
                                    <div className="print-box-teal">
                                        <div dangerouslySetInnerHTML={{ __html: nhanVien.congTrinhNBXB }} />
                                    </div>
                                </div>
                            )}

                            {/* Mục 6: Thành viên Hội nghề nghiệp */}
                            {!isRichTextEmpty(nhanVien.thanhVienHoiNghe) && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart1++}. Thành viên Hội nghề nghiệp</h5>
                                    <div className="print-box-teal">
                                        <div dangerouslySetInnerHTML={{ __html: nhanVien.thanhVienHoiNghe }} />
                                    </div>
                                </div>
                            )}

                            {/* Mục 7: Giải thưởng và danh hiệu */}
                            {!isRichTextEmpty(nhanVien.giaiThuongDanhHieu) && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart1++}. Giải thưởng và danh hiệu</h5>
                                    <div className="print-box-teal">
                                        <div dangerouslySetInnerHTML={{ __html: nhanVien.giaiThuongDanhHieu }} />
                                    </div>
                                </div>
                            )}

                            <div className="text-center my-5 font-weight-bold" style={{ fontSize: '14pt' }}>**********</div>

                            <div className="text-center mb-4">
                                <h5 className="font-weight-bold text-uppercase" style={{ fontSize: '13pt' }}>PHẦN 2</h5>
                                <h5 className="font-weight-bold" style={{ fontSize: '12pt' }}>(Thông tin chi tiết về kết quả nghiên cứu khoa học và đào tạo)</h5>
                            </div>

                            {/* 2.1 Bài báo khoa học đã công bố */}
                            {baiBao.length > 0 && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart2++}. Bài báo khoa học đã công bố</h5>
                                    
                                    {/* 1.1 Bài báo đăng trên tạp chí Quốc tế */}
                                    {baiBao.filter(b => [1, 2, 3, '1', '2', '3'].includes(b.loaiTapChi)).length > 0 && (
                                        <div className="mb-3">
                                            <h6 className="font-weight-bold font-italic mb-2" style={{ fontSize: '12pt' }}>{indexPart2 - 1}.1 Bài báo khoa học đăng trên tạp chí Quốc tế</h6>
                                            <Table striped bordered hover responsive>
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th style={{ textAlign: 'center', width: '5%' }}>TT</th>
                                                        <th style={{ textAlign: 'left', width: '35%' }}>Tên bài báo/báo cáo KH</th>
                                                        <th style={{ textAlign: 'center', width: '10%' }}>Số tác giả</th>
                                                        <th style={{ textAlign: 'center', width: '10%' }}>Là tác giả chính</th>
                                                        <th style={{ textAlign: 'left', width: '25%' }}>Tên tạp chí hoặc kỷ yếu khoa học/ ISSN hoặc ISBN</th>
                                                        <th style={{ textAlign: 'center', width: '10%' }}>Tập, số, trang</th>
                                                        <th style={{ textAlign: 'center', width: '10%' }}>Tháng, năm công bố</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {baiBao.filter(b => [1, 2, 3, '1', '2', '3'].includes(b.loaiTapChi)).map((b, idx) => (
                                                        <tr key={b.id}>
                                                            <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                            <td><strong>{b.tenBaiBao}</strong></td>
                                                            <td style={{ textAlign: 'center' }}>{b.soTacGia}</td>
                                                            <td style={{ textAlign: 'center' }}>
                                                                {[1, 2, '1', '2'].includes(b.vaiTroTacGia) ? 'x' : ''}
                                                            </td>
                                                            <td>
                                                                {b.tenTapChi}
                                                                {b.issnIsbn && ` (ISSN: ${b.issnIsbn})`}
                                                            </td>
                                                            <td style={{ textAlign: 'center' }}>{b.tapSoTrang || ''}</td>
                                                            <td style={{ textAlign: 'center' }}>{b.nam}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}

                                    {/* 1.2 Bài báo đăng trên tạp chí Quốc gia */}
                                    {baiBao.filter(b => [4, 5, '4', '5'].includes(b.loaiTapChi)).length > 0 && (
                                        <div className="mb-3">
                                            <h6 className="font-weight-bold font-italic mb-2" style={{ fontSize: '12pt' }}>{indexPart2 - 1}.2 Bài báo khoa học đăng trên tạp chí Quốc gia</h6>
                                            <Table striped bordered hover responsive>
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th style={{ textAlign: 'center', width: '5%' }}>TT</th>
                                                        <th style={{ textAlign: 'left', width: '35%' }}>Tên bài báo/báo cáo KH</th>
                                                        <th style={{ textAlign: 'center', width: '10%' }}>Số tác giả</th>
                                                        <th style={{ textAlign: 'center', width: '10%' }}>Là tác giả chính</th>
                                                        <th style={{ textAlign: 'left', width: '25%' }}>Tên tạp chí hoặc kỷ yếu khoa học/ ISSN hoặc ISBN</th>
                                                        <th style={{ textAlign: 'center', width: '10%' }}>Tập, số, trang</th>
                                                        <th style={{ textAlign: 'center', width: '10%' }}>Tháng, năm công bố</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {baiBao.filter(b => [4, 5, '4', '5'].includes(b.loaiTapChi)).map((b, idx) => (
                                                        <tr key={b.id}>
                                                            <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                            <td><strong>{b.tenBaiBao}</strong></td>
                                                            <td style={{ textAlign: 'center' }}>{b.soTacGia}</td>
                                                            <td style={{ textAlign: 'center' }}>
                                                                {(() => {
                                                                    const val = b.vaiTroTacGia;
                                                                    if (val === 1 || val === '1') return 'Chính';
                                                                    if (val === 2 || val === '2') return 'Liên hệ';
                                                                    if (val === 3 || val === '3') return 'Phụ';
                                                                    const found = VAI_TRO_BAI_BAO.find(o => o.value === val);
                                                                    if (found) {
                                                                        if (found.label.includes('chính')) return 'Chính';
                                                                        if (found.label.includes('liên hệ')) return 'Liên hệ';
                                                                        if (found.label.includes('phụ') || found.label.includes('Đồng tác giả')) return 'Phụ';
                                                                    }
                                                                    return val || 'Phụ';
                                                                })()}
                                                            </td>
                                                            <td>
                                                                {b.tenTapChi}
                                                                {b.issnIsbn && ` (ISSN: ${b.issnIsbn})`}
                                                            </td>
                                                            <td style={{ textAlign: 'center' }}>{b.tapSoTrang || ''}</td>
                                                            <td style={{ textAlign: 'center' }}>{b.nam}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* 2.2 Nhiệm vụ khoa học và công nghệ */}
                            {deTai.length > 0 && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart2++}. Nhiệm vụ khoa học và công nghệ</h5>
                                    <Table striped bordered hover responsive>
                                        <thead className="bg-light">
                                            <tr>
                                                <th style={{ textAlign: 'center', width: '5%' }}>TT</th>
                                                <th style={{ textAlign: 'left', width: '40%' }}>Tên nhiệm vụ khoa học và công nghệ (CT, ĐT...)</th>
                                                <th style={{ textAlign: 'center', width: '10%' }}>CN/PCN/TK</th>
                                                <th style={{ textAlign: 'left', width: '15%' }}>Mã số và cấp quản lý</th>
                                                <th style={{ textAlign: 'center', width: '15%' }}>Thời gian thực hiện</th>
                                                <th style={{ textAlign: 'center', width: '15%' }}>Thời gian nghiệm thu (ngày, tháng, năm)/Xếp loại KQ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {deTai.map((d, idx) => (
                                                <tr key={d.id}>
                                                    <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                    <td><strong>{d.tenNhiemVu}</strong></td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {(() => {
                                                            const val = d.vaiTro;
                                                            if (val === 1 || val === '1') return 'CN';
                                                            if (val === 2 || val === '2') return 'PCN';
                                                            if (val === 3 || val === '3') return 'TK';
                                                            if (val === 4 || val === '4') return 'TV';
                                                            const found = VAI_TRO_DE_TAI.find(o => o.value === val);
                                                            if (found) {
                                                                if (found.label.includes('Chủ nhiệm')) return 'CN';
                                                                if (found.label.includes('Phó chủ nhiệm')) return 'PCN';
                                                                if (found.label.includes('Thư ký')) return 'TK';
                                                                if (found.label.includes('Thành viên')) return 'TV';
                                                            }
                                                            return val;
                                                        })()}
                                                    </td>
                                                    <td>{CAP_DE_TAI.find(o => o.value === d.maSoCapQuanLy)?.label || d.maSoCapQuanLy}</td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {(() => {
                                                            if (!d.thoiGianTuNgay) return '';
                                                            const fTu = formatDateTimeWithoutHour(d.thoiGianTuNgay);
                                                            const fDen = d.thoiGianDenNgay ? formatDateTimeWithoutHour(d.thoiGianDenNgay) : '';
                                                            const getDisplay = (dateStr) => {
                                                                if (!dateStr) return '';
                                                                const parts = dateStr.split('/');
                                                                if (parts.length === 3) {
                                                                    if (parts[0] === '01' && parts[1] === '01') return parts[2];
                                                                    return `${parts[1]}/${parts[2]}`;
                                                                }
                                                                return dateStr;
                                                            };
                                                            const tuDisplay = getDisplay(fTu);
                                                            const denDisplay = getDisplay(fDen);
                                                            return denDisplay ? `${tuDisplay} - ${denDisplay}` : tuDisplay;
                                                        })()}
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {d.thoiGianNghiemThu && <div>{formatDateTimeWithoutHour(d.thoiGianNghiemThu)}</div>}
                                                        <div>
                                                            {(() => {
                                                                const val = d.xepLoaiKetQua;
                                                                if (val === 1 || val === '1') return 'Xuất sắc';
                                                                const found = XEP_LOAI_KET_QUA.find(o => o.value === val);
                                                                return found ? found.label : (val || 'Chưa nghiệm thu');
                                                            })()}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                            {/* 2.3 Bằng độc quyền sáng chế, giải pháp hữu ích */}
                            {sangChe.length > 0 && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart2++}. Bằng độc quyền sáng chế, giải pháp hữu ích</h5>
                                    <Table striped bordered hover responsive>
                                        <thead className="bg-light">
                                            <tr>
                                                <th style={{ textAlign: 'center', width: '5%' }}>TT</th>
                                                <th style={{ textAlign: 'left', width: '40%' }}>Tên bằng độc quyền sáng chế, giải pháp hữu ích</th>
                                                <th style={{ textAlign: 'left', width: '25%' }}>Tên cơ quan cấp</th>
                                                <th style={{ textAlign: 'center', width: '10%' }}>Ngày tháng năm cấp</th>
                                                <th style={{ textAlign: 'center', width: '10%' }}>Tác giả chính/ đồng tác giả</th>
                                                <th style={{ textAlign: 'center', width: '10%' }}>Số tác giả</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sangChe.map((s, idx) => (
                                                <tr key={s.id}>
                                                    <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                    <td><strong>{s.tenBangSangChe}</strong></td>
                                                    <td>{s.tenCoQuanCap}</td>
                                                    <td style={{ textAlign: 'center' }}>{formatDateTimeWithoutHour(s.ngayThangNamCap)}</td>
                                                    <td style={{ textAlign: 'center' }}>{VAI_TRO_SANG_CHE.find(o => o.value === s.vaiTroTacGia)?.label || s.vaiTroTacGia}</td>
                                                    <td style={{ textAlign: 'center' }}>{s.soTacGia}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                            {/* 2.4 Biên soạn sách phục vụ đào tạo */}
                            {sach.length > 0 && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart2++}. Biên soạn sách phục vụ đào tạo</h5>
                                    <Table striped bordered hover responsive>
                                        <thead className="bg-light">
                                            <tr>
                                                <th style={{ textAlign: 'center', width: '5%' }}>TT</th>
                                                <th style={{ textAlign: 'left', width: '25%' }}>Tên sách</th>
                                                <th style={{ textAlign: 'center', width: '15%' }}>Loại sách(CK, GT, TK, HD)</th>
                                                <th style={{ textAlign: 'left', width: '15%' }}>Nhà xuất bản và năm xuất bản</th>
                                                <th style={{ textAlign: 'center', width: '10%' }}>Số tác giả</th>
                                                <th style={{ textAlign: 'center', width: '10%' }}>Số chương biên soạn</th>
                                                <th style={{ textAlign: 'center', width: '10%' }}>Chủ biên</th>
                                                <th style={{ textAlign: 'center', width: '10%' }}>Phần biên soạn (từ trang ... đến trang)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sach.map((s, idx) => (
                                                <tr key={s.id}>
                                                    <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                    <td><strong>{s.tenSach}</strong></td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {(() => {
                                                            const val = s.loaiSach;
                                                            if (val === 1 || val === '1') return 'CK';
                                                            if (val === 2 || val === '2') return 'GT';
                                                            if (val === 3 || val === '3') return 'TK';
                                                            if (val === 4 || val === '4') return 'HD';
                                                            return val;
                                                        })()}
                                                    </td>
                                                    <td>{s.nhaXuatBan} ({s.namXuatBan})</td>
                                                    <td style={{ textAlign: 'center' }}>{s.soTacGia}</td>
                                                    <td style={{ textAlign: 'center' }}>{s.soChuongSach || '-'}</td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {(() => {
                                                            const val = s.vaiTro;
                                                            if (val === 1 || val === '1') return 'Chủ biên';
                                                            if (val === 2 || val === '2') return 'Đồng chủ biên';
                                                            if (val === 3 || val === '3') return 'Tác giả viết chương sách';
                                                            if (val === 4 || val === '4') return 'Thành viên ban biên soạn';
                                                            return val;
                                                        })()}
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>{s.phanBienSoanTuTrang} - {s.phanBienSoanDenTrang}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                            {/* 2.5 Hướng dẫn Học viên */}
                            {huongDanHocVien.length > 0 && (
                                <div className="mb-4">
                                    <h5 className="font-weight-bold mb-2" style={{ fontSize: '13pt' }}>{indexPart2++}. Hướng dẫn Học viên</h5>
                                    <Table striped bordered hover responsive>
                                        <thead className="bg-light">
                                            <tr>
                                                <th rowSpan={2} style={{ textAlign: 'center', width: '5%' }}>TT</th>
                                                <th rowSpan={2} style={{ textAlign: 'left', width: '15%' }}>Họ tên NCS hoặc HVCH/CK2/BSNT</th>
                                                <th colSpan={2} style={{ textAlign: 'center', width: '10%' }}>Đối tượng</th>
                                                <th colSpan={3} style={{ textAlign: 'center', width: '15%' }}>Trách nhiệm hướng dẫn</th>
                                                <th rowSpan={2} style={{ textAlign: 'left', width: '20%' }}>Tên đề tài</th>
                                                <th rowSpan={2} style={{ textAlign: 'left', width: '20%' }}>Cơ sở đào tạo/thời điểm BV</th>
                                                <th rowSpan={2} style={{ textAlign: 'left', width: '15%' }}>Thời gian đào tạo (QĐ)</th>
                                            </tr>
                                            <tr>
                                                <th style={{ textAlign: 'center' }}>NCS</th>
                                                <th style={{ textAlign: 'center' }}>CH/CK2/BSNT</th>
                                                <th style={{ textAlign: 'center' }}>Chính</th>
                                                <th style={{ textAlign: 'center' }}>Phụ</th>
                                                <th style={{ textAlign: 'center' }}>Đồng HD</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {huongDanHocVien.map((h, idx) => (
                                                <tr key={h.id}>
                                                    <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                    <td><strong>{h.hoTenHocVien}</strong></td>
                                                    <td style={{ textAlign: 'center' }}>{h.doiTuong === 1 ? 'X' : ''}</td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {h.doiTuong !== 1 ? (() => {
                                                            const val = h.doiTuong;
                                                            if (val === 2) return 'CH';
                                                            if (val === 3) return 'CK2';
                                                            if (val === 4) return 'BSNT';
                                                            return val;
                                                        })() : ''}
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>{h.trachNhiemHuongDan === 1 ? 'X' : ''}</td>
                                                    <td style={{ textAlign: 'center' }}>{h.trachNhiemHuongDan === 2 ? 'X' : ''}</td>
                                                    <td style={{ textAlign: 'center' }}>{h.trachNhiemHuongDan === 3 ? 'X' : ''}</td>
                                                    <td>{h.tenDeTai}</td>
                                                    <td>{h.coSoDaoTao} ({h.thoiDiemBaoVe || 'Chưa BV'})</td>
                                                    <td>{h.thoiGianDaoTaoTu && h.thoiGianDaoTaoDen ? `${formatDateTimeWithoutHour(h.thoiGianDaoTaoTu)} - ${formatDateTimeWithoutHour(h.thoiGianDaoTaoDen)}` : '-'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                            <div className="text-center my-5 font-weight-bold" style={{ fontSize: '14pt' }}>**********</div>

                            <div className="mt-5 print-signature-section" style={{ fontSize: '12pt', pageBreakInside: 'avoid' }}>
                                <div style={{ textAlign: 'right', fontStyle: 'italic', marginBottom: '10px' }}>
                                    Hà Nội, Ngày {String(new Date().getDate()).padStart(2, '0')} tháng {String(new Date().getMonth() + 1).padStart(2, '0')} năm {new Date().getFullYear()}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <div style={{ width: '300px', textAlign: 'center' }}>
                                        <div className="font-weight-bold text-uppercase" style={{ fontSize: '12pt' }}>NGƯỜI KHAI</div>
                                        <div style={{ height: '80px' }}></div>
                                        <div className="font-weight-bold" style={{ fontSize: '12pt' }}>{nhanVien.hoTen}</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>
                            <div style={{ height: '2.5cm' }}></div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default PrintLayoutV2;
